import firebase from 'firebase/app';
//import { initializeApp, } from 'firebase/app';

import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyAF-Pe75_SfRQOhNNBVAV6dz6SVHO1NnLA",
    authDomain: "vzlacondominios.firebaseapp.com",
    projectId: "vzlacondominios",
    storageBucket: "vzlacondominios.appspot.com",
    messagingSenderId: "373628455473",
    appId: "1:373628455473:web:3aff9985bb36dc8569a310",
    measurementId: "G-8Q55YK9W59"
  };
  // Initialize Firebase
  //firebase.initializeApp(firebaseConfig);
  //firebase.analytics();

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const firebaseStorage = firebase.storage();
  //const app = initializeApp(firebaseConfig);
  //const storage = app.storage();

  export { firebaseApp, firebaseStorage, }
  //export { app, storage, }